import type { PropsWithChildren, ReactNode } from 'react'
import { sva } from '~/styled-system/css'
import type { RecipeVariantProps } from '~/styled-system/css'
import { vstack } from '~/styled-system/patterns'

const styles = sva({
  slots: ['root', 'heading'],
  base: {
    root: vstack.raw({
      gap: '3',
      alignItems: 'start',
      w: 'full',
    }),
    heading: {
      fontSize: 'lg',
      fontWeight: 'bold',
      px: '3',
      _pc: {
        px: '0',
      },
    },
  },
  variants: {
    size: {
      large: {
        root: {
          _pc: {
            gap: '5',
          },
        },
        heading: {
          _pc: {
            fontSize: '3xl',
          },
        },
      },
      medium: {
        root: {
          _pc: {
            gap: '5',
          },
        },
        heading: {
          _pc: {
            fontSize: '2xl',
          },
        },
      },
      small: {
        root: {
          _pc: {
            gap: '3',
          },
        },
        heading: {
          _pc: {
            color: 'gray.700',
            fontSize: 'xl',
          },
        },
      },
    },
  },
})

type Props = PropsWithChildren<{
  heading: ReactNode
}> &
  RecipeVariantProps<typeof styles>

// TODO: 見出しに注意書きを追加するタイミングで annotation?: ReactNode を受け取って見出しを作る
//       apps/web/src/features/reservationInput/sd/Section.tsx を参照
export function GuideSection({ heading, size, children }: Props) {
  const classes = styles({ size })
  return (
    <section className={classes.root}>
      <h3 className={classes.heading}>{heading}</h3>
      {children}
    </section>
  )
}
